// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + (chunkId === 524 ? "app" : chunkId) + "." + {"271":"fad37cc3","360":"3ebda8a7","524":"5e7d2ffe","548":"116e9321","583":"ce88993f"}[chunkId] + ".bundle.js";
};